// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
/* tslint:disable */
import * as i from '../interfaces/index';

import * as e from '../enums/index';

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class Property implements i.PropertyInterface {
  name: string;
  type: e.Type;
  repeated: boolean;
  properties: Property[];

  constructor(kwargs?: i.PropertyInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Property {
    let m = new Property();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue<e.Type>(e.Type, proto.type);
    }
    if (proto.properties) {
      m.properties = proto.properties.map(Property.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.name === 'undefined' &&
      typeof this.type === 'undefined' &&
      typeof this.repeated === 'undefined' &&
      typeof this.properties === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.repeated !== 'undefined') {
      toReturn['repeated'] = this.repeated;
    }
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? (this.properties as any).toApiJson() : this.properties;
    }
    return toReturn;
  }
}

export class Schema implements i.SchemaInterface {
  properties: Property[];

  constructor(kwargs?: i.SchemaInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Schema {
    let m = new Schema();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(Property.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.properties === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? (this.properties as any).toApiJson() : this.properties;
    }
    return toReturn;
  }
}
